<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="feedback-providers-section">
  <div class="feedback-providers-section-top">
    <div class="title-container">
      <ptl-editable-section-title [title]="section?.title" (titleSaved)="saveTitle($event)"> </ptl-editable-section-title>
    </div>
    <ptl-report-top-actions [editIsEnabled]="false" (sectionDelete)="openDialog(section?.uid)">
      <ng-content></ng-content>
    </ptl-report-top-actions>
  </div>

  <div class="feedback-providers-section-inner">
    <mat-card class="feedback-providers-item" *ngFor="let item of [0, 1, 2]">
      <div class="provider-info-box">
        <div class="icon-box">
          <img width="225" height="225" src="assets/profile_image.png" alt="Provider image" />
        </div>
        <div class="provider-info">
          <div class="name medium bold">Caroline Bigbsy-Waller</div>
          <div class="position medium italic">Head of Marketing</div>
          <div class="university medium">Bigsby Space Tech</div>
        </div>
      </div>
    </mat-card>
  </div>
</section>
